var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          attrs: {
            color: "green",
            timeout: 1000,
            "auto-height": true,
            "auto-width": true,
            top: ""
          },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.snackbarMessage) + "\n  ")]
      ),
      _vm._v(" "),
      _c("span", { staticStyle: { "font-size": "0.8rem" } }, [
        _vm._v("Custom Views")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "k-cv-container" },
        [
          [
            _c(
              "v-menu",
              {
                attrs: {
                  "close-on-content-click": false,
                  "close-on-click": false,
                  "content-class": "k-cv-menu",
                  lazy: "",
                  "min-width": "250px",
                  "max-width": "250px",
                  transition: "scale-transition",
                  "nudge-left":
                    _vm.firstMenuIconClicked && _vm.menuIconClickCount == 0
                      ? 0
                      : 7,
                  "offset-y": "",
                  "full-width": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-text-field",
                          _vm._g(
                            {
                              ref: "input",
                              class: {
                                "select-mode": !_vm.createMode,
                                "create-input": true,
                                pointer:
                                  !_vm.createMode &&
                                  (!_vm.activeCustomView ||
                                    _vm.activeCustomView.disabled)
                              },
                              staticStyle: { width: "250px" },
                              attrs: {
                                outline: "",
                                label: _vm.createMode ? "Create New" : null,
                                placeholder: _vm.createMode
                                  ? "Enter new view name"
                                  : "Select",
                                "hide-details": "",
                                disabled: _vm.loading,
                                readonly:
                                  !_vm.createMode &&
                                  (!_vm.activeCustomView ||
                                    _vm.activeCustomView.disabled),
                                error: _vm.errorMsg
                              },
                              on: { focus: _vm.handleInputFocus },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    var attr = ref.attr
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.createMode,
                                                                  expression:
                                                                    "createMode"
                                                                }
                                                              ],
                                                              attrs: {
                                                                color: "error"
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.cancelCreate
                                                              }
                                                            },
                                                            "v-icon",
                                                            attr,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            "\n                    close\n                  "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: !_vm.createMode,
                                                                  expression:
                                                                    "!createMode"
                                                                }
                                                              ],
                                                              attrs: {
                                                                color: "link"
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.openMenu
                                                              }
                                                            },
                                                            "v-icon",
                                                            attr,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            "arrow_drop_down\n                  "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.createMode
                                                    ? "Cancel Create"
                                                    : "Expand"
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.textInput,
                                callback: function($$v) {
                                  _vm.textInput = $$v
                                },
                                expression: "textInput"
                              }
                            },
                            on
                          )
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.showMenu,
                  callback: function($$v) {
                    _vm.showMenu = $$v
                  },
                  expression: "showMenu"
                }
              },
              [
                _vm._v(" "),
                _c(
                  "v-list",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.createMode,
                        expression: "!createMode"
                      }
                    ],
                    staticStyle: { padding: "0" }
                  },
                  [
                    _c(
                      "v-expansion-panel",
                      { staticClass: "custom-view-expansion-panel" },
                      _vm._l(_vm.customViews, function(customView, i) {
                        return _c(
                          "v-expansion-panel-content",
                          {
                            key: i,
                            attrs: { "expand-icon": null },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "k-cv-header",
                                          class: {
                                            active:
                                              _vm.activeCustomView &&
                                              _vm.activeCustomView
                                                .CustomViewId ==
                                                customView.CustomViewId
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "k-cv-name" },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  _vm._s(
                                                    customView.expanded
                                                      ? "expand_less"
                                                      : "expand_more"
                                                  )
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "heading",
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectCustomView(
                                                    customView,
                                                    true,
                                                    $event
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(customView.name) +
                                                  "\n                    "
                                              ),
                                              customView.DefaultView
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "0.8rem",
                                                        color:
                                                          "rgba(0, 0, 0, 0.6)"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Default view\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !customView.disabled
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "k-delete-cv-btn",
                                                  attrs: { icon: "", flat: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleDeleteBtnClick(
                                                        customView.CustomViewId,
                                                        $event
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("delete")
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: customView.expanded,
                              callback: function($$v) {
                                _vm.$set(customView, "expanded", $$v)
                              },
                              expression: "customView.expanded"
                            }
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-list",
                              { staticStyle: { padding: "0" } },
                              [
                                _c(
                                  "v-list-tile",
                                  { staticClass: "k-cv-collapse-content" },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          { staticClass: "k-cv-tile-title" },
                                          [
                                            _vm._v(
                                              "\n                      Filters:\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          {
                                            staticClass: "k-cv-tile-sub-title"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(customView.filterText) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile",
                                  { staticClass: "k-cv-collapse-content" },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          { staticClass: "k-cv-tile-title" },
                                          [_vm._v("Sort:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          {
                                            staticClass: "k-cv-tile-sub-title"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(customView.sortText) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile",
                                  { staticClass: "k-cv-collapse-content" },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          { staticClass: "k-cv-tile-title" },
                                          [_vm._v("Columns:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          {
                                            staticClass: "k-cv-tile-sub-title"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(customView.columnsText) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile",
                                  { staticClass: "k-cv-collapse-content" },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          { staticClass: "k-cv-tile-title" },
                                          [_vm._v("Group By:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          {
                                            staticClass: "k-cv-tile-sub-title"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(customView.groupByText) +
                                                "\n                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile",
                                  { staticClass: "k-cv-collapse-content" },
                                  [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          { staticClass: "k-cv-tile-title" },
                                          [_vm._v("Pagination:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-sub-title",
                                          {
                                            staticClass: "k-cv-tile-sub-title"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "100%",
                                                  display: "flex",
                                                  "justify-content":
                                                    "space-between"
                                                }
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    "Page: " +
                                                      _vm._s(customView.page)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                          Page Size:\n                          " +
                                                      _vm._s(
                                                        customView.isAllApplied
                                                          ? "All"
                                                          : customView.pageSize
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("v-divider"),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass:
                          "k-filter-menu-item active k-cv-create-btn",
                        attrs: { flat: "", color: "primary" },
                        on: { mousedown: _vm.handleCreateNewClick }
                      },
                      [_vm._v("\n            Create New\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.createMode,
                        expression: "createMode"
                      }
                    ],
                    staticStyle: { padding: "0" }
                  },
                  [
                    _c(
                      "v-list-tile",
                      { staticClass: "k-cv-collapse-content" },
                      [
                        _c(
                          "v-list-tile-content",
                          [
                            _c(
                              "v-list-tile-title",
                              { staticClass: "k-cv-tile-title" },
                              [
                                _vm._v(
                                  "\n                Filters:\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-sub-title",
                              { staticClass: "k-cv-tile-sub-title" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.newCustomView.filterText) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile",
                      { staticClass: "k-cv-collapse-content" },
                      [
                        _c(
                          "v-list-tile-content",
                          [
                            _c(
                              "v-list-tile-title",
                              { staticClass: "k-cv-tile-title" },
                              [_vm._v("Sort:")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-sub-title",
                              { staticClass: "k-cv-tile-sub-title" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.newCustomView.sortText) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile",
                      { staticClass: "k-cv-collapse-content" },
                      [
                        _c(
                          "v-list-tile-content",
                          [
                            _c(
                              "v-list-tile-title",
                              { staticClass: "k-cv-tile-title" },
                              [_vm._v("Columns:")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-sub-title",
                              { staticClass: "k-cv-tile-sub-title" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.newCustomView.columnsText) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile",
                      { staticClass: "k-cv-collapse-content" },
                      [
                        _c(
                          "v-list-tile-content",
                          [
                            _c(
                              "v-list-tile-title",
                              { staticClass: "k-cv-tile-title" },
                              [_vm._v("Group By:")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-sub-title",
                              { staticClass: "k-cv-tile-sub-title" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.newCustomView.groupByText) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile",
                      { staticClass: "k-cv-collapse-content" },
                      [
                        _c(
                          "v-list-tile-content",
                          [
                            _c(
                              "v-list-tile-title",
                              { staticClass: "k-cv-tile-title" },
                              [_vm._v("Pagination:")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-sub-title",
                              { staticClass: "k-cv-tile-sub-title" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _vm._v("Page: " + _vm._s(_vm.page))
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                    Page Size:\n                    " +
                                          _vm._s(
                                            _vm.isAllApplied
                                              ? "All"
                                              : _vm.pageSize
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          _vm._v(" "),
          _vm.createMode ||
          (_vm.activeCustomView && !_vm.activeCustomView.disabled)
            ? [
                _c("v-checkbox", {
                  staticClass: "default-checkbox mt-0 pt-0",
                  attrs: { color: "link", label: "Make Default" },
                  model: {
                    value: _vm.makeDefaultFlag,
                    callback: function($$v) {
                      _vm.makeDefaultFlag = $$v
                    },
                    expression: "makeDefaultFlag"
                  }
                }),
                _vm._v(" "),
                _c(
                  "v-tooltip",
                  {
                    attrs: { top: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            var attr = ref.attr
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: { color: "link" },
                                      on: { click: _vm.saveView }
                                    },
                                    "v-icon",
                                    attr,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v("\n            save\n          ")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3791067308
                    )
                  },
                  [_vm._v(" "), _c("span", [_vm._v("Save View")])]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.errorMsg
            ? _c("div", { staticClass: "k-cv-error k-fade-in pt-1" }, [
                _vm._v("\n      " + _vm._s(_vm.errorMsg) + "\n    ")
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }